import React from "react";

import { useTheme } from "@mui/material";
import Stack from "@mui/material/Stack";

export interface ButtonsProps {
  children?: React.ReactNode;
}

export const Buttons = ({ children }: ButtonsProps) => {
  const theme = useTheme();
  return (
    <Stack
      direction="row"
      spacing={2}
      sx={{
        flexShrink: 0,
        padding: 4,
        borderTop: `1px solid ${theme.igBorders.core.default}`,
      }}
    >
      {children}
    </Stack>
  );
};
